function CardBomber() {
  return (
    <>
      <h2 id="cardbomber">Card Bomber (2016)</h2>
      <p>
        This is the final project of my Grade 11 Computer Science course
        (ICS3U0). The purpose of this project is to create a game in Java with
        the HSA Console library that was used throughout the semester.
      </p>
      <p>
        This game was inspired by Voltorb Flip. The game functions like the Card
        Bomber App described <a href="#gamescreen">above</a>, except it is
        controlled using WASD keys for movements and the Enter key for
        selecting.
      </p>
      <p>
        The GitHub repository is{" "}
        <a
          href="https://github.com/dkhl65/Card-Bomber"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        . The project files are{" "}
        <a href="https://1drv.ms/u/s!Arlw0YD7zqYNhmITCutfpFVd7GrB">here</a>.
      </p>
      <img
        alt="cardbomber"
        src="https://1drv.ms/i/c/0da6cefb80d170b9/UQS5cNGA-86mIIANjyYAAAAAAPk-1-h_8MQCeiE?width=672&height=590"
      />
      <div>The home screen of the program.</div>
    </>
  );
}

export default CardBomber;
